import { Box, variables } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const Container = styled(Box)`
  &.MuiBox-root {
    background: ${variables.color.background};
    display: flex;
    align-items: center;
    flex-direction: column;

    height: calc(100vh);
    padding-top: 80px;
  }
`;
